<template>
  <div class="panel-content" v-if="currItem.screen_text">
    <question-description :currItem="currItem" :code="currItem.topic_type"></question-description>
    <div class="panel-content-ask">
      <div v-for="(item, index) in askList" :key="index" v-if="index > 0">
        <span class="item-content">（{{ item }}</span>
      </div>
    </div>
    <div class="panel-content-artical">
      <p v-for="(item, index) in currItem.screen_text" :key="index" v-if="index > 0">
        {{ item.content }}
      </p>
    </div>
    <div class="panel-content-input">
      <el-input v-if="isExamMode" :placeholder="$t('write_artical_title')" v-model="inputTitle" maxlength="20" @change="handlerSubmit" class="inputTitle" clearable> </el-input>
      <el-input v-if="isExamMode" type="textarea" :autosize="{ minRows: 8 }" :placeholder="$t('write_artical_content')" v-model="inputText" :maxlength="limitLength" @input="textInput" @change="handlerSubmit"> </el-input>
      <p v-if="isExamMode" class="limit">{{ wordLength }}/500</p>
      <div v-if="!isExamMode" class="show-result">
        <p class="title">{{ inputTitle }}</p>
        <p class="text" v-for="(item, index) in inputTextResult" :key="index">
          {{ item }}
        </p>
      </div>
      <p v-if="!isExamMode" class="limit-all">{{ computedSome }}/400</p>
    </div>
    <div class="panel-content-result" v-if="!isExamMode">
      <p class="orange">{{ $t('hsk_reference_answer') }}</p>
      <p class="correct-answer" v-for="(item, index) in answerText" :key="index">
        {{ item }}
      </p>
    </div>
    <div class="correct-box" v-if="!isExamMode && analysisText">
      <p class="correct-box-title">{{ $t('hsk_answer_analysis') }}</p>
      <p class="correct-box-answer">
        {{ analysisText }}
      </p>
    </div>
  </div>
</template>

<script>
import QuestionDescription from '@/components/hsk/questionDescription'
import { getAllWordsLength } from '@/utils/utils'

export default {
  components: { QuestionDescription },
  data() {
    return {
      inputText: '',
      inputTitle: '',
      askList: [],
      blankNum: 0,
      inputTextResult: [],
    }
  },
  computed: {
    language() {
      let local = localStorage.getItem('language')
      if (local == 'zh') {
        return 'cn'
      } else {
        return local
      }
    },
    computedSome() {
      let inputTextNumber = this.inputTextResult.length
        ? this.inputTextResult?.reduce(function (a, b) {
            return a + b
          })?.length
        : 0
      return this.inputTitle?.length + inputTextNumber
    },
    answerText() {
      return this.currItem.evaluate.standard_answer[0].split('\n')
    },
    analysisText() {
      return this.currItem.analysis[this.language] ? this.currItem.analysis[this.language] : this.currItem.analysis['zh']
    },
    limitLength() {
      return 500 + this.blankNum
    },
    wordLength() {
      return getAllWordsLength(this.inputText)
    },
  },
  watch: {
    currItem: {
      handler(val) {
        if (val && val.index) {
          console.log('val===', val)
          this.askList = val.screen_text[0].content.split('（')
          if (val.answer) {
            this.inputTitle = val.answer.split('&&')[0]
            this.inputText = val.answer.split('&&')[1]
            if (!this.isExamMode) {
              console.log(val.answer)
              this.inputTextResult = val.answer.split('&&')[1].split('\n') || []
              console.log(this.inputTextResult)
            }
          }
        }
      },
      immediate: true,
    },
  },
  props: {
    //当前试题项
    currItem: {
      type: Object,
      required: true,
    },
    isExamMode: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    //输入框监听
    textInput(e) {
      this.inputText = e
    },
    // titleInput(e) {
    //   this.titleInput = e
    // },
    handlerSubmit() {
      let key_words_must = this.currItem.evaluate.key_words_must ?? []
      let provide_words = this.currItem.evaluate.provide_words
      let mustWords = key_words_must.concat(provide_words)
      let answerLength = this.currItem.evaluate?.length?.split('-') ?? []
      answerLength = answerLength.map((item) => {
        item = parseInt(item)
        return item
      })
      let ansObj = {
        questionId: this.currItem.index,
        answer: this.inputTitle + '&&' + this.inputText,
        judge: 0,
        scores: null,
        segmentCode: this.currItem.segment_code,
        partCode: this.currItem.part_code,
        ifGroup: this.currItem.ifGroup,
        topic_type: this.currItem.topic_type,
        evaluate: {
          category: 'abbreviation',
          answer: this.inputTitle + '\n' + this.inputText,
          full_marks: this.currItem.score,
          reference_answer: JSON.stringify(this.currItem.evaluate.standard_answer),
          answer_length_range: JSON.stringify(answerLength),
          keywords: JSON.stringify(mustWords),
          unnecessary_keywords: JSON.stringify(this.currItem.evaluate.key_words_optional),
          original_text: this.currItem.evaluate.original_text,
          questionId: this.currItem.index,
        },
      }
      this.inputTextResult = this.inputText.split('\n')
      //选中后延时1ms再提交
      setTimeout(() => {
        this.$emit('saveRes', ansObj)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.panel-content {
  width: 100%;
  padding: 30px 29px 20px 29px;
  position: relative;
  .ques-area-des {
    position: absolute;
    left: 29px;
    top: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #b5b5be;
    margin-top: 0px;
  }
  &-ask {
    margin: 20px 0px 25px 0px;
    padding: 15px;
    width: 100%;
    height: 157px;
    background: #f6f7fc;
    border-radius: 5px;
    line-height: 25px;
    .item-key {
      font-size: 14px;
      font-weight: 400;
      color: #9fa4af;
    }
    .item-content {
      font-size: 14px;
      font-weight: 500;
      color: #3e4651;
    }
  }
  &-artical {
    margin-bottom: 30px;
    p {
      text-indent: 2em;
      font-size: 14px;
      font-weight: 400;
      color: #393d46;
      line-height: 25px;
    }
  }
  &-input {
    margin-bottom: 40px;
    position: relative;
    .limit {
      position: absolute;
      bottom: 5px;
      right: 5px;

      font-size: 12px;
      font-weight: 400;
      color: #c6cad4;
    }
    .limit-all {
      font-weight: 600;
      font-size: 14px;
      color: #2c2f46;
      margin-top: 10px;
      text-align: right;
    }
    .inputTitle {
      margin-bottom: 20px;
    }
    .show-result {
      .title {
        width: 100%;
        text-align: center;
        font-size: 24px;
        font-weight: bold;
        color: #393d46;
        margin-bottom: 20px;
      }
      .text {
        font-size: 14px;
        font-weight: 400;
        color: #3e4651;
        line-height: 25px;
        // text-indent: 2em;
      }
    }
  }
  &-result {
    width: 100%;
    border-top: 1px dashed #e6eaef;
    padding: 30px 0px;
    .correct-answer {
      font-size: 14px;
      color: #545961;
      line-height: 25px;
      text-indent: 2em;
    }
    .orange {
      font-size: 14px;
      font-weight: 500;
      color: #fc5a5a;
      margin-bottom: 20px;
    }
  }
  .correct-box {
    background: rgba(251, 252, 255, 1);
    border: 1px solid rgba(242, 243, 247, 1);
    border-radius: 10px;
    padding: 20px;

    &-title {
      font-size: 14px;
      font-weight: bold;
      color: rgba(63, 70, 81, 1);
      margin-bottom: 10px;
    }
    &-answer {
      font-size: 14px;
      font-weight: 400;
      color: rgba(84, 89, 97, 1);
      line-height: 21px;
      white-space: pre-line;
    }
  }
}
</style>
